import { render, staticRenderFns } from "./DeadlinesCalendar.vue?vue&type=template&id=0bc08a20&"
import script from "./DeadlinesCalendar.vue?vue&type=script&lang=ts&"
export * from "./DeadlinesCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports